export default "__VITE_ASSET__CsxnnOA0__"